export const TIME_OUT_TIME = 20 * 60 // in seconds (minutes * seconds)
export const WARN_BEFORE_TIME = 60 // in seconds
